'use client';

import { clsx } from 'clsx';
import { DallasTextVariant } from '../types/typography';
import DallasSkeleton from '../Skeleton/DallasSkeleton';

import styles from './DallasTextSkeleton.module.scss';

export interface Props {
  className?: string;
  variant?: DallasTextVariant;
  partialLine?: boolean;
  fullLine?: boolean;
}

export default function DallasTextSkeleton({
  className,
  variant = 'body',
  partialLine,
  fullLine,
}: Props) {
  return (
    <DallasSkeleton
      className={clsx(className, styles.root, styles[`variant_${variant}`])}
      variant="text"
      width={fullLine ? '100%' : partialLine ? '60%' : 100}
    />
  );
}
